import { serviceApi } from '~/api/service';
import qs from 'qs';

const slotsUrl = (queryParams) => `time-slots?${queryParams}`;

export const timeSlotsApi = {
  getTimeSlots: (storeId, appointmentTypeIds, date, partnerId) => {
    const queryParams = qs.stringify(
      {
        storeId,
        appointmentTypeIds: appointmentTypeIds.join(','),
        date,
        partnerId: partnerId || null /** avoid empty query */,
      },
      { skipNulls: true, encode: false },
    );
    return serviceApi.fetchJSON(slotsUrl(queryParams));
  },
};
